import { put, call, takeLatest } from 'redux-saga/effects'
import fetchFromAPI, { getDefaultAutorizedHeaders } from 'helpers/fetchFromApi'
import NoticeHelper from 'helpers/notice'
import UrlHelper from 'helpers/url'
import * as ApiRouter from 'constants/apiRouting'
import { SHOW_NOTICE } from 'reducers/notice'
import { IS_ADMIN_QUERY_PARAM } from 'constants/index'
import {
  FETCH_JOB_INPUT_TABLE_DATA,
  FETCH_JOB_INPUT_TABLE_DATA_SUCCESS,
  FETCH_JOB_INPUT_TABLE_DATA_FAILURE,
  FETCH_JOB_WORKFLOW_INPUT_ITEM,
  FETCH_JOB_WORKFLOW_INPUT_ITEM_SUCCESS,
  FETCH_JOB_WORKFLOW_INPUT_ITEM_FAILURE,
  FETCH_JOB_WORKFLOWS,
  FETCH_JOB_WORKFLOWS_SUCCESS,
  FETCH_JOB_WORKFLOWS_FAILURE,
  FETCH_JOB_WORKFLOW_TASKS,
  FETCH_JOB_WORKFLOW_TASKS_SUCCESS,
  FETCH_JOB_WORKFLOW_TASKS_FAILURE,
  FETCH_JOB_WORKFLOW_INPUT_GROUPS,
  FETCH_JOB_WORKFLOW_INPUT_GROUPS_SUCCESS,
  FETCH_JOB_WORKFLOW_INPUT_GROUPS_FAILURE,
  FETCH_INPUT_TYPES,
  FETCH_INPUT_TYPES_SUCCESS,
  FETCH_INPUT_TYPES_FAILURE,
  FETCH_INPUTS_OPTIONS_SOURCE,
  FETCH_INPUTS_OPTIONS_SOURCE_SUCCESS,
  FETCH_INPUTS_OPTIONS_SOURCE_FAILURE,
  FETCH_DEPENDENCY_INPUTS_FAILURE,
  FETCH_DEPENDENCY_INPUTS,
  FETCH_DEPENDENCY_INPUTS_SUCCESS,
  FETCH_JOB_INPUT_POSITION_UPDATE,
  SUCCESS_JOB_INPUT_POSITION_UPDATE,
  SAVE_JOB_INPUTS_INFO,
  DELETE_JOB_INPUTS_ITEM,
  FETCH_TASK_NUMBER_INPUTS,
  FETCH_TASK_NUMBER_INPUTS_SUCCESS,
  FETCH_TASK_NUMBER_INPUTS_FAILURE,
  FETCH_LOOKUP_TABLES_SOURCE,
  FETCH_LOOKUP_TABLES_SOURCE_SUCCESS,
  FETCH_LOOKUP_TABLES_SOURCE_FAILURE,
  FETCH_LOOKUP_CONDITIONS,
  FETCH_LOOKUP_CONDITIONS_SUCCESS,
  FETCH_LOOKUP_CONDITIONS_FAILURE,
  FETCH_ALLOWED_LOOKUP_COLUMNS,
  FETCH_ALLOWED_LOOKUP_COLUMNS_SUCCESS,
  FETCH_ALLOWED_LOOKUP_COLUMNS_FAILURE,
  PATCH_JOB_WORKFLOW_INPUTS,
} from './reducer'
import { fetchJobInputItemsTable } from '../jobInputItemsAdmin/saga'

function* patchJobWorkflowInputs(action) {
  try {
    const previewInputs = action.payload

    for (let i = 0; i < previewInputs.length; i += 1) {
      // eslint-disable-next-line no-unused-vars
      const { id, title, ...rest } = previewInputs[i]

      const response = yield call(fetchFromAPI, {
        headers: getDefaultAutorizedHeaders(),
        method: 'PATCH',
        partUrl: UrlHelper.create(ApiRouter.JOB_WORKFLOW_INPUTS_ITEM, { id }),
        data: { ...rest },
      })

      if (response.error) {
        return yield call(action.promise.resolve, response.errors)
      }
    }
  } catch (error) {
    throw new Error(`PATCH JOB WORKFLOW INPUT ERROR: ${error}`)
  }
}

function* fetchJobInputsTable({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.JOB_WORKFLOW_INPUTS_TABLE}${UrlHelper.getPsfsQuery(
        payload,
      )}`,
    })

    if (response && !response.error) {
      yield put({ type: FETCH_JOB_INPUT_TABLE_DATA_SUCCESS, payload: response })
    } else {
      yield put({ type: FETCH_JOB_INPUT_TABLE_DATA_FAILURE })
    }
  } catch (error) {
    console.log('FETCH JOB INPUT DATA ERROR', error)
  }
}

function* fetchJobWorkflows({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.JOB_WORKFLOWS}${UrlHelper.getPsfsQuery(
        payload,
      )}&${IS_ADMIN_QUERY_PARAM}`,
    })

    if (response && !response.error) {
      yield put({ type: FETCH_JOB_WORKFLOWS_SUCCESS, payload: response })
    } else {
      yield put({ type: FETCH_JOB_WORKFLOWS_FAILURE })
    }
  } catch (error) {
    console.log('FETCH JOB WORKFLOWS ERROR', error)
  }
}

function* fetchJobWorkflowTasks({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.JOB_WORKFLOW_TASKS}${UrlHelper.getPsfsQuery(
        payload,
      )}&${IS_ADMIN_QUERY_PARAM}`,
    })

    if (response && !response.error) {
      yield put({ type: FETCH_JOB_WORKFLOW_TASKS_SUCCESS, payload: response })
    } else {
      yield put({ type: FETCH_JOB_WORKFLOW_TASKS_FAILURE })
    }
  } catch (error) {
    console.log('FETCH JOB WORKFLOW TASKS ERROR', error)
  }
}

function* fetchJobWorkflowInputGroups({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.JOB_WORKFLOW_INPUT_GROUPS}${UrlHelper.getPsfsQuery(
        payload,
      )}`,
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_JOB_WORKFLOW_INPUT_GROUPS_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_JOB_WORKFLOW_INPUT_GROUPS_FAILURE })
    }
  } catch (error) {
    console.log('FETCH JOB WORKFLOW INPUT GROUPS ERROR', error)
  }
}

function* fetchInputTypes() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRouter.JOB_WORKFLOW_INPUTS_TYPE,
    })

    if (response && !response.error) {
      yield put({ type: FETCH_INPUT_TYPES_SUCCESS, payload: response })
    } else {
      yield put({ type: FETCH_INPUT_TYPES_FAILURE })
    }
  } catch (error) {
    console.log('FETCH INPUT TYPES ERROR', error)
  }
}

function* fetchTaskNumberInputs({
  payload: { entityId, inputGroup },
  promise,
}) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(ApiRouter.JOB_WORKFLOW_TASK_NUMBERS, {
        id: entityId,
      })}${inputGroup ? `?group=${inputGroup}` : ''}`,
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_TASK_NUMBER_INPUTS_SUCCESS,
        payload: response,
      })
    } else {
      yield put({
        type: FETCH_TASK_NUMBER_INPUTS_FAILURE,
      })
    }

    return yield call(promise.resolve, false)
  } catch (error) {
    console.log('FETCH TASK FORMDATA ERROR', error)
  }
}

function* fetchInputsOptionsSource() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRouter.JOB_WORKFLOW_INPUTS_OPTIONS_SOURCE,
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_INPUTS_OPTIONS_SOURCE_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_INPUTS_OPTIONS_SOURCE_FAILURE })
    }
  } catch (error) {
    console.log('FETCH INPUTS OPTIONS SOURCE ERROR', error)
  }
}

function* fetchLookupTablesSource() {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: ApiRouter.LOOKUP_TABLES_SOURCE,
    })

    if (response && !response.error) {
      yield put({ type: FETCH_LOOKUP_TABLES_SOURCE_SUCCESS, payload: response })
    } else {
      yield put({ type: FETCH_LOOKUP_TABLES_SOURCE_FAILURE })
    }
  } catch (error) {
    console.log('FETCH LOOKUP TABLES SOURCE ERROR', error)
  }
}

function* fetchLookupConditions({
  payload: { tableId, jobTask, inputGroup, currentInput },
}) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(
        ApiRouter.JOB_WORKFLOW_TASK_LOOKUP_CONDITIONS,
        {
          id: jobTask,
        },
      )}?table=${tableId}${inputGroup ? `&group=${inputGroup}` : ''}${
        currentInput ? `&current=${currentInput}` : ''
      }`,
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_LOOKUP_CONDITIONS_SUCCESS,
        payload: Object.values(response),
      })
    } else {
      yield put({ type: FETCH_LOOKUP_CONDITIONS_FAILURE })
    }
  } catch (error) {
    console.log('FETCH LOOKUP CONDITIONS ERROR', error)
  }
}

function* fetchAllowedLookupColumns({
  payload: { tableId, inputGroup, currentInput },
}) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${UrlHelper.create(
        ApiRouter.JOB_WORKFLOW_INPUT_GROUPS_LOOKUPS,
        {
          id: inputGroup,
        },
      )}?table=${tableId}${currentInput ? `&input=${currentInput}` : ''}`,
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_ALLOWED_LOOKUP_COLUMNS_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_ALLOWED_LOOKUP_COLUMNS_FAILURE })
    }
  } catch (error) {
    console.log('FETCH ALLOWED LOOKUP COLUMNS ERROR', error)
  }
}

function* fetchDependencyInputs({ payload }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: `${ApiRouter.JOB_WORKFLOW_INPUTS}${UrlHelper.getPsfsQuery(
        payload,
      )}`,
    })

    if (response && !response.error) {
      yield put({ type: FETCH_DEPENDENCY_INPUTS_SUCCESS, payload: response })
    } else {
      yield put({ type: FETCH_DEPENDENCY_INPUTS_FAILURE })
    }
  } catch (error) {
    console.log('FETCH DEPENDENCY INPUTS FAILED', error)
  }
}

function* fetchJobWorkflowInputItem({ payload: { entityId } }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRouter.JOB_WORKFLOW_INPUTS_DETAILS, {
        id: entityId,
      }),
    })

    if (response && !response.error) {
      yield put({
        type: FETCH_JOB_WORKFLOW_INPUT_ITEM_SUCCESS,
        payload: response,
      })
    } else {
      yield put({ type: FETCH_JOB_WORKFLOW_INPUT_ITEM_FAILURE })
    }
  } catch (error) {
    console.log('FETCH JOB WORKFLOW INPUT ITEM', error)
  }
}

function* fetchJobInputPositionUpdate({ payload: { params, data, index } }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      method: 'PATCH',
      partUrl: UrlHelper.create(ApiRouter.JOB_WORKFLOW_POSITION_CHANGE, params),
      data,
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(
          'Job Input position successfully updated',
        ),
      })
      yield put({
        type: SUCCESS_JOB_INPUT_POSITION_UPDATE,
        payload: {
          index,
          position: data.position,
        },
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createWarningObj('Sorry, something went wrong'),
      })
    }
  } catch (error) {
    console.log('JOB INPUT POSITION UPDATE ERROR', error)
  }
}

function* saveJobInputsInfo({ payload: { entityId, data }, promise }) {
  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: entityId
        ? UrlHelper.create(ApiRouter.JOB_WORKFLOW_INPUTS_ITEM, { id: entityId })
        : ApiRouter.JOB_WORKFLOW_INPUTS,
      method: entityId ? 'PUT' : 'POST',
      data,
    })

    if (response.error) {
      const errorText = Object.values(response.errors)

      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(errorText),
      })
      yield call(promise.resolve, response.errors)
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj('Job Input Successfully Saved'),
      })
    }

    yield call(promise.resolve, false)
  } catch (error) {
    console.log('POST PUT JOB INPUT ERROR ', error)
  }
}

function* deleteJobInputItem(action) {
  const {
    payload: { entityId, entityType },
  } = action

  try {
    const response = yield call(fetchFromAPI, {
      headers: getDefaultAutorizedHeaders(),
      partUrl: UrlHelper.create(ApiRouter.JOB_WORKFLOW_INPUTS_ITEM, {
        id: entityId,
      }),
      method: 'DELETE',
    })

    if (response && !response.error) {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createSuccessObj(
          'Job Input was successfully deleted',
        ),
      })
    } else {
      yield put({
        type: SHOW_NOTICE,
        notice: NoticeHelper.createErrorObj(
          'Something went wrong when deleting',
        ),
      })
    }

    if (entityType === 'input') {
      yield fetchJobInputItemsTable(action)
    } else {
      yield fetchJobInputsTable(action)
    }
  } catch (error) {
    console.log('DELETE JOB INPUT ERROR', error)
  }
}

function* jobInputAdminSaga() {
  yield takeLatest(FETCH_JOB_INPUT_TABLE_DATA, fetchJobInputsTable)
  yield takeLatest(FETCH_JOB_WORKFLOW_INPUT_ITEM, fetchJobWorkflowInputItem)
  yield takeLatest(FETCH_JOB_WORKFLOWS, fetchJobWorkflows)
  yield takeLatest(FETCH_JOB_WORKFLOW_TASKS, fetchJobWorkflowTasks)
  yield takeLatest(FETCH_JOB_WORKFLOW_INPUT_GROUPS, fetchJobWorkflowInputGroups)
  yield takeLatest(FETCH_INPUT_TYPES, fetchInputTypes)
  yield takeLatest(FETCH_TASK_NUMBER_INPUTS, fetchTaskNumberInputs)
  yield takeLatest(FETCH_INPUTS_OPTIONS_SOURCE, fetchInputsOptionsSource)
  yield takeLatest(FETCH_LOOKUP_TABLES_SOURCE, fetchLookupTablesSource)
  yield takeLatest(FETCH_LOOKUP_CONDITIONS, fetchLookupConditions)
  yield takeLatest(FETCH_ALLOWED_LOOKUP_COLUMNS, fetchAllowedLookupColumns)
  yield takeLatest(FETCH_DEPENDENCY_INPUTS, fetchDependencyInputs)
  yield takeLatest(FETCH_JOB_INPUT_POSITION_UPDATE, fetchJobInputPositionUpdate)
  yield takeLatest(SAVE_JOB_INPUTS_INFO, saveJobInputsInfo)
  yield takeLatest(DELETE_JOB_INPUTS_ITEM, deleteJobInputItem)
  yield takeLatest(PATCH_JOB_WORKFLOW_INPUTS, patchJobWorkflowInputs)
}

export default jobInputAdminSaga
